<template>
	<Autocomplete
		:display-name="
			typeof label === 'string' ? t(label, multiple ? 2 : 1) : translate(label)
		"
		:icon="icon"
		:label="
			typeof label === 'string' ? t(label, multiple ? 2 : 1) : translate(label)
		"
		:endpoint="endpoint"
		:name="name"
		:multiple="multiple"
		:item-title="(item: Api.Building) => buildingDescription(item)"
		data-test="buildings-autocomplete"
		:custom-filter-fields="additionalCustomFilterFields"
		:chips="chips"
		v-bind="$attrs"
	>
		<template v-if="$slots.append" #append>
			<slot name="append"></slot>
		</template>
		<template v-if="chips" #chip="{ item, selected, props, to }">
			<v-chip v-bind="props" :to="to">
				{{ multiple ? selectedText(selected, item) : item.title }}
			</v-chip>
		</template>
		<template #item="{ item, props }">
			<v-list-item
				v-bind="props"
				:title="`${item.raw.address?.street ?? ''}, ${item.raw.address?.zip ?? ''} ${item.raw.address?.city ?? ''}`"
				:subtitle="`${FormatValue.getHpId(item.raw.hp_id)}${item.raw.building_type?.name ? ' - ' + item.raw.building_type.name : ''}`"
			>
			</v-list-item>
		</template>
	</Autocomplete>
</template>

<script setup lang="ts">
import { buildingDescription } from '@/filters'
import Autocomplete from '@/components/templates/Validation/Autocomplete.vue'
import { type PropType } from 'vue'
import type { FieldLabel } from 'templates/Validation/validation'
import { useTranslate } from 'composables/useTranslate.ts'
import FormatValue from 'helpers/FormatValue.ts'
import { useI18n } from 'vue-i18n'

defineProps({
	icon: {
		default: '$buildingDefault',
		type: String,
	},
	label: {
		default: 'entity.building.name',
		type: [String, Object] as PropType<FieldLabel>,
		required: false,
	},
	name: {
		default: 'buildings',
		type: String,
	},
	multiple: {
		type: Boolean,
		default: true,
	},
	endpoint: {
		default: 'buildings',
		type: String,
	},
	additionalCustomFilterFields: {
		type: Array as PropType<string[]>,
		default: () => ['hp_id'],
	},
	chips: {
		type: Boolean,
		default: false,
		required: false,
	},
})
const { t } = useI18n()
const { translate } = useTranslate()

function selectedText(selected, item) {
	return Array.isArray(selected) && selected.length <= 5
		? `${item.raw.hp_id} - ${item.raw.address.street}`
		: item.raw.hp_id
}
</script>

<style scoped></style>
